export const translations = {
	// 未查询到相关数据
	2004: "No relevant data found",
	// 未查询到相关数据，查询不到Frame码
	2005: "No relevant data found, no frame code found",
	// 程序异常，请联系客服
	500: "Program exception, please contact customer service",
};
